import { render } from "./MobileDataDownload.vue?vue&type=template&id=5c8e2b54&scoped=true"
import script from "./MobileDataDownload.vue?vue&type=script&lang=js"
export * from "./MobileDataDownload.vue?vue&type=script&lang=js"

import "./MobileDataDownload.vue?vue&type=style&index=0&id=5c8e2b54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8e2b54"]])

export default __exports__